import { render, staticRenderFns } from "./SimProductForm.vue?vue&type=template&id=b65a5e86&scoped=true&"
import script from "./SimProductForm.vue?vue&type=script&lang=ts&"
export * from "./SimProductForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65a5e86",
  null
  
)

export default component.exports